/**
 * Converts a JavaScript `File` object to a base64-encoded string.
 */
export async function fileToBase64(file: File): Promise<string> {
	const reader = new FileReader();
	reader.readAsDataURL(file);
	const fileAsBase64 = await new Promise<string>((resolve, reject) => {
		reader.onload = () => resolve((reader.result as string).replace(/^data:.+?;base64,/, ''));
		reader.onerror = () => reject(new Error(`Failed to read file ${file.name}`));
	});
	return fileAsBase64;
}
